import { DashboardVendedorFilters } from "../types/filter";
import { UpdateUserStatusRequest } from "../types/user";
import { CreateVendedor, CustomTeamRequest, ListaEquipos, VendedorCreated, VendedorForDashboard, VendedorItem } from "../types/vendedor";
import { apiSlice } from "../lib/baseQuery";
import { VendedorEndpointTags } from "./utils";

const BASE_URL = "/api/vendedores";

export const vendedorApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        getVendedoresDashboard: build.query<VendedorForDashboard[], DashboardVendedorFilters>({
            query: (filters: DashboardVendedorFilters)=> {
                const queryString = new URLSearchParams(filters).toString();
                return BASE_URL + "/dashboard" + `?${queryString}`;
            }
        }),
        getEquiposVentas: build.query<ListaEquipos, void>({
            query: () => BASE_URL + "/equipos",
            keepUnusedDataFor: 0,
            providesTags: [VendedorEndpointTags.GET_EQUIPOS_VENTAS],
        }),
        createCustomTeam: build.mutation<void, CustomTeamRequest>({
            query: (request: CustomTeamRequest) => ({
                url: BASE_URL + "/equipos",
                method: "POST",
                body: request
            }),
            invalidatesTags: [VendedorEndpointTags.GET_EQUIPOS_VENTAS],
        }),
        getVendedores: build.query<VendedorItem[], void>({
            query: () => BASE_URL,
        }),
        getVendedorById: build.query<VendedorItem, number>({
            query: (vendedorId) => BASE_URL + `/${vendedorId}`,
            providesTags: [VendedorEndpointTags.GET_VENDEDOR_BY_ID]
        }),
        createVendedor: build.mutation<VendedorCreated, CreateVendedor>({
            query: (request) => ({
                url: BASE_URL,
                method: "POST",
                body: { nombre: request.nombre, tipo: request.tipo },
            }),
        }),
        changeVendedorStatus: build.mutation<void, UpdateUserStatusRequest>({
            query: (request: UpdateUserStatusRequest) => ({
                url: `${BASE_URL}/status/${request.userId}`,
                method: "PUT",
                body: {
                    status: request.newStatus,
                }
            }),
            invalidatesTags: [VendedorEndpointTags.GET_VENDEDOR_BY_ID]
        })
    })
})

export const {
    useGetVendedoresDashboardQuery,
    useGetEquiposVentasQuery,
    useCreateCustomTeamMutation,
    useGetVendedoresQuery,
    useLazyGetVendedoresQuery,
    useCreateVendedorMutation,
    useGetVendedorByIdQuery,
    useChangeVendedorStatusMutation,
} = vendedorApi;